import React, { useEffect, useState } from 'react';
import './styles.css';
import { Table, Dropdown, Menu, Checkbox, Modal, Button, Space, Input, Form, message } from 'antd';
import { EllipsisOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { partnerChangeHistoryData, payoutDataWithPartner, remarkData } from '../helper/payoutdatasample';
// import { render } from '@testing-library/react';
import { Link, useNavigate } from 'react-router-dom';
import RemarksComponent from '../RemarksComponent';
import PartnerChangeHistory from '../PartnerChangeHistory';
import AddInvoice from '../AddInvoice';
import { data } from '../../PricingManagement/helper/PricingdashboardData';
import { addPayoutRemarksSuccess, getPayoutRemarksSuccess } from '../../../redux/PayoutPartnerData/action';
import { connect } from 'react-redux';
import { Payout_Service } from '../../../redux/Url';
import { use } from 'react';
import TextArea from 'antd/lib/input/TextArea';
import { getRaisePayoutQueryInternalAction, getResolvePayoutQueryInternalAction } from '../../../redux/PayoutQueryInternal/Action';
import { partnerApprovalStagesSuccess } from '../../../redux/PayoutApprovalStages/action';
import { getInvoiceData } from '../../../redux/PayoutPartnerInvoiceUpload/Action';
import { Spin } from 'antd';



const PartnerListWithPayout = (props) => {

  const {
    landataSource,
    setLanDatasource,
    makerAction,
    checkerAction,
    utrAction,
    makerPartnerAction,
    setMakerAction,
    setCheckerAction,
    setMakerPartnerAction,
    handleRadioChange,
    radiostate,
    setRadioState,
    handleCheckboxChange,
    selectedCheckboxes,
    pagination,
    ReportId,
    currentStage,
    fetchPaginatedData,
    fetchPayoutStagesData,
    downloading

  } = props;

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [datasource, setDatasource] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [partnerChangeOpen, setPartnerChangeOpen] = useState(false);
  const [partnerChangeData, setPartnerChangeData] = useState(partnerChangeHistoryData);
  const [invoiceData, setInvoiceData] = useState([]);
  const [value, setValue] = useState('');
  const [remarks, setRemarks] = useState(false);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [resolveQueryModal, setResolveQueryModal] = useState(false);
  const [partnerRemarks, setPartnerRemarks] = useState([]);
  const [approveRemarks, setApproveRemarks] = useState('');
  const [isApproveModal, setIsApproveModal] = useState(false);
  const [remarkComment, setRemarkComment] = useState('');
  const [documentDatalength, setDocumentDataLength] = useState();
  const [raiseQueryModal, setRaiseQueryModal] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [isRemarksLoading, setIsRemarksLoading] = useState(null);
  const [isPaidModal, setIsPaidModal] = useState(false);


  useEffect(() => {
    setDatasource(landataSource);
  }, [landataSource, radiostate]);



  const handleSelectAllChange = (e, action) => {
    const checked = e.target.checked;
  }



  // Fetch remarks for a partner
  const fetchPartnerRemarks = async (partnerId) => {
    try {


      const getRemarks = await props.getPayoutRemarks({
        accessToken: props.accessToken,
        reportId: ReportId, // Assuming ReportId is the report ID you want to use
        partnerId: partnerId,
      })
      const data = await getRemarks;
      setPartnerRemarks(data || []); // Assuming the API returns data in a 'data' field
      // Optionally dispatch to Redux if needed:
      // props.getPayoutRemarksSuccess(data);
      return data;
    } catch (error) {
      setPartnerRemarks([]);
      return [];
    }
  };

  const handleRemarksModal = async (partnerId, key) => {
    setIsRemarksLoading(key);
    setSelectedPartnerId(partnerId);
    setRemarks(true);
    setPartnerRemarks([]);
    await fetchPartnerRemarks(partnerId);
    setIsRemarksLoading(null)
  };

  const handelAddRemarks = async (remarkComment, partnerId = selectedPartnerId) => {



    const remarksData = {
      "partnerId": partnerId,
      "reportId": ReportId,
      "userId": props.userDetail?.userId,
      "remarksComment": remarkComment,
      "stage": currentStage,
      "remarkType": "Partner"
    };
    const resReamatkadd = await props.PartnerRemarkadd({
      accessToken: props.accessToken,
      remarks: remarksData
    });

    await fetchPartnerRemarks(partnerId);

  }


  const handleMenuClick = (record, action) => {
  };

  const formatRemarks = (remarks) => {
    const sortdata = remarks.sort((a, b) => {
      const dateA = new Date(a.createDateTime);
      const dateB = new Date(b.createDateTime);

      return dateA.getTime() - dateB.getTime(); // Newest first
    });

    return remarks
      ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .map((remarks) => (
        <div className='containerRemarks' style={{ display: 'block' }} key={remarks.userName}>
          <div style={{ display: 'flex' }}>
            <b>{remarks.userName}</b>
            <b className='userRole' >({remarks.userRole})</b>
          </div>
          <div style={{ display: 'grid' }} className='commentContainer'>
            <span style={{ maxWidth: "200px" }}> {remarks.remarksComment} </span>
            <small>
              {new Date(remarks.createDateTime).toLocaleString()}
            </small>
          </div>
        </div>
      ));
  };

  var resData = formatRemarks(remarkData)

  const showModal = async (data) => {

    const rest = await fetchInvoicedata(data);
    setIsModalOpen(true);

    // setInvoiceData(data);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setResolveQueryModal(false);
    setRaiseQueryModal(false);
    setIsApproveModal(false);
    setRemarkComment('');
    setApproveRemarks('');
    setIsPaidModal(false);
    form.resetFields();
    setIsLoading(false);
  };

  const handleSubmit = (value, record) => {
    // printing the value on save

    // clear the value after set
    setValue('');
  }

  const handleChange = (event) => {
    // setAddRemarks(event.target.value);
    const value = event.target.value;
    if (value.length <= 250) {
      setRemarkComment(value);
      setApproveRemarks(value);
    } else {
      message.error("You can only enter a maximum of 250 characters.");
    }
  }

  const handleHeaderMenuClick = async (key) => {
    switch (key) {
      case 'ExportCSV':
        await downloadReport('csv');
        break;
      case 'ExportExcel':
        await downloadReport('excel');
        break;
      case 'AddRemark':
        setRemarks(true)
        break;
      case 'PartnerChangeHistory':
        setPartnerChangeOpen(true)
        break;
      case 'DownloadAll':
        break;
      default:
    }
  };

  const fetchInvoicedata = async (reportdata) => {

    const invoicedata = await props.getInvoiceData({
      accessToken: props.accessToken,
      partnerId: reportdata.partnerId,
      reportId: ReportId,
    })

    setInvoiceData(invoicedata?.data?.invoiceDetails);

  }

  const downloadReport = async (format) => {
    try {
      const response = await fetch(
        // `http://localhost:8301/partner-payout-service/reports/download/partner?report_id=${ReportId}&approval_stage_id=${currentStage}&format=${format}`,
        `${Payout_Service}/reports/download/partner?report_id=${ReportId}&approval_stage_id=${currentStage}&format=${format}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
          },
        }
      );
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Download failed:', error);
    }
  };


  const handelnavtolandata = (partner, ReportId) => {

    navigate(`landata/${partner.partnerFirmName}`, {
      state: {
        partnerFirmName: partner.partnerFirmName + "/" + partner.partnerDisplayCode,
        partnerId: partner.partnerId,
        ReportId: ReportId
      }
    });

  }

  const handleResolveQueryModal = (partnerId) => {
    setSelectedPartnerId(partnerId);
    setResolveQueryModal(true);
  };

  const handleResolveQuery = async () => {
    setIsLoading(true);
    if (remarkComment.trim() === '') {
      message.error('Invalid input. Please enter a valid remark.');
      form.resetFields();
      setRemarkComment('');
      return;
    }

    // console.log("checked partner:",selectedCheckboxes);
    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];
    const parentIdq = selectedPartnerId;
    const queryData = {
      "partnerid": parentIdq,
      "reportid": ReportId,
      "userId": props.userDetail?.userId,
      "stage": 5,
      "payoutid": [],
      "remarks": {
        "partnerId": parentIdq,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 5,
        "remarkType": "PartnerQuery"
      }
    };

    const resQuery = await props.resolveQuery({
      accessToken: props.accessToken,
      query: queryData
    });
    await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
    message.success("Query resolved successfully");
    form.resetFields();
    setRemarkComment('');
    setResolveQueryModal(false);
    setSelectedPartnerId(null);
    setRadioState("All");

    // Refresh data after resolving query
    fetchPayoutStagesData();
    fetchPaginatedData(currentStage, "All");
    setIsLoading(false);

  }

  const handleApproveModal = (partnerId) => {
    setIsApproveModal(true);
    setSelectedPartnerId(partnerId);
  };

  const handlePaidModal = (partnerId) => {
    setIsPaidModal(true);
    setSelectedPartnerId(partnerId);
  };

  const handleApproveSubmit = async () => {

    setIsLoading(true);

    if (approveRemarks.trim() === '') {
      message.error('Invalid input. Please enter a valid remark.');
      form.resetFields();
      setApproveRemarks('');
      return;
    }

    try {
      const partnerid = selectedPartnerId;
      const approvedData = {
        "partnerId": partnerid,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": approveRemarks,
        "stage": 8, // Assuming 8 is the ID for the CET Checker stage
        "remarkType": "PartnerApproved"
      };
      await props.partnerApprovalStagesSuccess({
        accessToken: props.accessToken,
        approvalStageId: 8,
        monthlyReportId: ReportId,
        partnerId: partnerid,
        approveData: approvedData,
      });
      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
      message.success('Partner approved successfully!'); // Show success message
      form.resetFields();
      setApproveRemarks(''); // Clear the approve remarks input
      setIsApproveModal(false); // Close the modal
      fetchPayoutStagesData(); // Refresh the stages data
      fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission


    } catch (error) {
      console.error("Error submitting approve remarks:", error);
      message.error('Failed to approve partner. Please try again.'); // Show error message
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaidSubmit = async () => {

    setIsLoading(true);

    if (approveRemarks.trim() === '') {
      message.error('Invalid input. Please enter a valid remark.');
      form.resetFields();
      setApproveRemarks('');
      return;
    }

    try {
      const partnerid = selectedPartnerId;
      const approvedData = {
        "partnerId": partnerid,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": approveRemarks,
        "stage": 11, // Assuming 11 is the ID for the Paid stage
        "remarkType": "PartnerApproved"
      };
      await props.partnerApprovalStagesSuccess({
        accessToken: props.accessToken,
        approvalStageId: 11, // Assuming 11 is the ID for the Paid stage
        monthlyReportId: ReportId,
        partnerId: partnerid,
        approveData: approvedData,
      });

      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
      message.success('Invoiced processed  successfully!'); // Show success message
      form.resetFields();
      setApproveRemarks(''); // Clear the approve remarks input
      setIsPaidModal(false); // Close the modal
      fetchPayoutStagesData(); // Refresh the stages data
      fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission


    } catch (error) {
      console.error("Error submitting approve remarks:", error);
      message.error('Failed to approve partner. Please try again.'); // Show error message
    } finally {
      setIsLoading(false);
    }
  };

  const handleRaiseQueryModal = (partnerId) => {
    setSelectedPartnerId(partnerId);
    setRaiseQueryModal(true);
  };

  const handleRaiseQuery = async () => {

    setIsLoading(true);

    if (remarkComment.trim() === '') {
      message.error('Invalid input. Please enter a valid remark.');
      form.resetFields();
      setRemarkComment('');
      return;
    }
    // console.log("Raise Query for partnerId:", selectedPartnerId);
    // console.log("checked partner:",selectedCheckboxes);
    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];
    const parentIdq = selectedPartnerId;
    const queryData = {
      "partnerid": [parentIdq],
      "reportid": ReportId,
      "userId": props.userDetail?.userId,
      "stage": 5,
      "payoutid": [],
      "remarks": {
        "partnerId": parentIdq,
        "reportId": ReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 5,
        "remarkType": "PartnerQuery"
      }
    };

    const resQuery = await props.RaiseQuery({
      accessToken: props.accessToken,
      query: queryData
    });

    await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
    message.success('Query raised successfully!');
    form.resetFields();
    setRemarkComment('');
    setRaiseQueryModal(false);
    fetchPayoutStagesData();
    fetchPaginatedData(currentStage, radiostate); // Refresh the data after submission
    setSelectedPartnerId(null);
    setIsLoading(false);

  }



  const headerMenu = (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key)}
      items={[
        { label: 'Export to CSV', key: 'ExportCSV' },
        { label: 'Export to Excel', key: 'ExportExcel' },
        // { label: 'Partner Change History', key: 'PartnerChangeHistory' },
        // { label: 'Add/ View Remark(Partner)', key: 'AddRemark' },
        // { ...utrAction ? { label: 'Download All Invoices', key: 'DownloadAll' } : {} }
      ]}
    />
  );

  const columns = [
    // ...(makerAction || checkerAction ? [
    //   {
    //     title: "Check",
    //     dataIndex: "Check",
    //     key: "Check",
    //     fixed: "left",
    //     width: 60,
    //     render: (_, record) => (
    //       <Checkbox
    //         checked={selectedCheckboxes.Check.includes(record)}
    //         onChange={(e) => handleCheckboxChange(e, "Check", record)}
    //       />
    //     ),
    //   },
    // ] : []),
    {
      title: 'Partner Name',
      dataIndex: 'partnerFirmName',
      key: 'partnerFirmName',
      align: 'center',
      fixed: "left",
      width: 200,
      onCell: (partner) => ({
        className: partner.internalQuery === true ? 'partner-cell-bg' : '',
      }),
      render: (_, partner) => (
        //<Link to={`landata/${partner.partnerFirmName}`} style={{ color: "#1b8593", textDecoration: 'none' }}>
        <p
          onClick={() => { handelnavtolandata(partner, ReportId) }}
          style={{
            color: "#1b8593",
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          {partner.partnerFirmName}
        </p>
      ),
    },

    {
      title: 'Partner Code',
      dataIndex: 'partnerDisplayCode',
      key: 'partnerDisplayCode',
      align: 'center',
    },
    // {
    //   title: 'Channel Type',
    //   dataIndex: 'ChannelType',
    //   key: 'ChannelType',
    // },
    {
      title: 'Total Disb Amt',
      dataIndex: 'totalDisbAmount',
      key: 'totalDisbAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Total Loan Count',
      dataIndex: 'totalDisbCount',
      key: 'totalDisbCount',
      align: 'center',
      width: 190,
    },
    {
      title: '1st Disb Amt',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche Disb Amt',
      dataIndex: 'tranchPayout',
      key: 'tranchPayout',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Gross Payout',
      dataIndex: 'grossPayout',
      key: 'grossPayout',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Payout On Hold',
      dataIndex: 'payoutOnHold',
      key: 'payoutOnHold',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Recovery Amount',
      dataIndex: 'recoveryAmount',
      key: 'recoveryAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Retro Adj',
      dataIndex: 'retroAdjustment',
      key: 'retroAdjustment',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Miscellaneous Credit Amount',
      dataIndex: 'miscCreditAmount',
      key: 'miscCreditAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Miscellaneous Debit Amount',
      dataIndex: 'miscDebitAmount',
      key: 'miscDebitAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Net Payout',
      dataIndex: 'netPayout',
      key: 'netPayout',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    // {
    //   title: 'Net Payout Incl GST',
    //   dataIndex: 'netPayoutWithGst',
    //   key: 'netPayoutWithGst',
    //   align:'center',
    // },
    {
      title: 'Remark',
      dataIndex: 'Remark',
      key: 'Remark',
      align: 'center',
      render: (_, partner, key) => (
        <Button loading={isRemarksLoading === key} className='remarkView-btn' style={{ border: "none", color: "#000", fontSize: "12px" }} onClick={() => handleRemarksModal(partner.partnerId, key)} >
          View
        </Button>
      )
    },

    ...(makerPartnerAction || makerAction || checkerAction ? [{
      title: (
        currentStage > 3 ?
          <span style={{ cursor: 'not-allowed', color: '#ccc' }}>
            View <EllipsisOutlined />
          </span>
          :
          <Dropdown overlay={headerMenu} trigger={['click']}>
            <span style={{ cursor: 'pointer' }}>
              View <EllipsisOutlined />
            </span>
          </Dropdown>
      ),
      dataIndex: 'Action',
      key: 'Action',
      align: 'center',
      width: 50,
      render: (_, record) => {
        const menu = (
          <Menu
            onClick={({ key }) => handleMenuClick(record, key)}
            disabled={record.documentData ? false : true}
            items={[
              { label: 'Agreement', key: 'Agreement' },
              { label: 'GST Certificate', key: 'GSTCertificate' },
              { label: 'Dual Name Certificate', key: 'DualNameCertificate' },
            ]}
          />
        );

        return (
          <div className='view-container'>
            {/* <Dropdown className="btn" overlay={menu} trigger={['click']}>
              <span> Documents </span>
            </Dropdown> */}
            {currentStage === 7 || currentStage === 11 ? <Button disabled={invoiceData ? false : true} className='btn' type="primary" onClick={() => showModal(record)}>
              Invoice
            </Button> : null}
            {currentStage === 6 ? <Button className='btn' type="primary" style={{ marginLeft: "2%" }} onClick={() => handleResolveQueryModal(record.partnerId)}>
              Resolve Query
            </Button> : null}
            {currentStage === 7 ? <Button className='btn' type="primary" style={{ marginLeft: "2%" }} onClick={() => handleRaiseQueryModal(record.partnerId)}>
              Raise Query
            </Button> : null}
            {currentStage === 7 ? <Button className='btn' type="primary" style={{ marginLeft: "2%" }} onClick={() => handleApproveModal(record.partnerId)}>
              Approve
            </Button> : null}
            {currentStage === 10 ? <Button className='btn' type="primary" style={{ marginLeft: "2%" }} onClick={() => handlePaidModal(record.partnerId)}>
              Paid
            </Button> : null}

          </div>
        );
      },
    }] : []),
    ...(utrAction ? [{
      title: 'UTR',
      dataIndex: 'UTRUpdate',
      key: 'UTRUpdate',
      render: (_, record) => (
        <Form onSubmit={handleSubmit}>
          <Form.Item
            label=""
            placeholder="UTRUpdate"
            name="UTRUpdate"
            style={{ width: "200px", marginTop: "10px", }}
          >
            <Input
              style={{ width: "100%", margin: "0px" }}
              placeholder="UTR number"
              onChange={handleChange}
            />
          </Form.Item>
        </Form>
      )
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      key: 'Action',
      render: (_, record) => (
        <Button style={{ marginLeft: 10, backgroundColor: '#1b8593', color: '#fff', fontSize: '0.7rem', margin: '3px', borderRadius: '5px' }} onClick={() => handleSubmit(value, record)}>SAVE</Button>
      )
    }] : [])



  ];

  //   const sortedDatasource = [...datasource].sort((a, b) => {
  //   // Put internalQuery === true items first
  //   if (a.internalQuery === b.internalQuery) return 0;
  //   return a.internalQuery ? -1 : 1;
  // });

  const sortedDatasource = [...datasource].sort((a, b) => {
    const aHasPriority = a.internalQuery || a.anyLanRemapped;
    const bHasPriority = b.internalQuery || b.anyLanRemapped;

    if (aHasPriority === bHasPriority) return 0;
    return aHasPriority ? -1 : 1;
  });

  return (
    <>
      <div style={{ maxWidth: '100%', overflow: "auto" }}>
        {downloading && (
          <div style={{
            position: 'absolute',
            zIndex: 10,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Spin tip="Loading..." size="large" />
          </div>
        )}
        <Table dataSource={sortedDatasource}
          pagination={pagination}
          onChange={(pagination) => {
            // Call the parent's handler if provided
            if (props.onPageChange) {
              props.onPageChange(pagination.current, pagination.pageSize, currentStage);
            }

          }}
          columns={columns} rowKey={(record, index) => index} scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
          rowClassName={(record) => {
            if (record.internalQuery) return 'green-bottom-border';
            if (record.anyLanRemapped) return 'blue-bottom-border';
            return '';
          }}
        />

      </div>

      <Modal open={resolveQueryModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            handleResolveQuery();
          }}
        >
          <Form.Item
            name="QueryRemark"
            label="Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}>
            <TextArea
              style={{ marginTop: 20 }}
              placeholder='Please add Query Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}
              maxLength={250}
              showCount={true}
            />
          </Form.Item>
          <Button disabled={isloading} loading={isloading} className='btn-query' htmlType="submit" type="primary">
            Submit Query
          </Button>
        </Form>
      </Modal>

      <Modal open={raiseQueryModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            handleRaiseQuery();
          }}
        >
          <Form.Item
            name="QueryRemark"
            label="Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}>
            <TextArea
              // style={{ marginTop: 20 }}
              placeholder='Please add Query Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}
              maxLength={250}  // Limit to 250 characters
              showCount={true}  // Show character count
            />
          </Form.Item>
          <Button loading={isloading} className='btn-query' htmlType="submit" type="primary">
            Submit Query
          </Button>
        </Form>
      </Modal>

      <Modal open={isApproveModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ ApproveRemarks }) => {
            setApproveRemarks(ApproveRemarks);
            handleApproveSubmit();
          }}
        >
          <Form.Item
            name="ApproveRemarks"
            label="Approve Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              // style={{ marginTop: 20 }}
              placeholder='Please add Approve Remark'
              value={approveRemarks}
              onChange={handleChange}  // Add this line to handle input changes
              autoSize={{ minRows: 3, maxRows: 5 }}
              maxLength={250}  // Limit to 250 characters
              showCount={true}  // Show character count
            />
          </Form.Item>
          <Button loading={isloading} className='btn-query' htmlType="submit" type="primary">
            Approve
          </Button>
        </Form>
      </Modal>

      <Modal open={isPaidModal} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
        <Form
          form={form}
          onFinish={({ ApproveRemarks }) => {
            setApproveRemarks(ApproveRemarks);
            handlePaidSubmit();
          }}
        >
          <Form.Item
            name="ApproveRemarks"
            label="Paid Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              // style={{ marginTop: 20 }}
              placeholder='Please add Approve Remark'
              value={approveRemarks}
              onChange={handleChange}  // Add this line to handle input changes
              autoSize={{ minRows: 3, maxRows: 5 }}
              maxLength={250}  // Limit to 250 characters
              showCount={true}  // Show character count
            />
          </Form.Item>
          <Button loading={isloading} className='btn-query' htmlType="submit" type="primary">
            Paid
          </Button>
        </Form>
      </Modal>

      <PartnerChangeHistory
        resData={resData}
        partnerChangeOpen={partnerChangeOpen}
        setPartnerChangeOpen={setPartnerChangeOpen}
        partnerChangeData={partnerChangeData}
        setPartnerChangeData={setPartnerChangeData}
      />

      <RemarksComponent
        resData={formatRemarks(partnerRemarks)}
        remarks={remarks}
        setRemarks={setRemarks}
        handelAddRemarks={handelAddRemarks}
        setRemarkComment={setRemarkComment}
        isHistory={makerAction ? false : true}

      />
      <AddInvoice
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        invoiceData={invoiceData}
        setInvoiceData={setInvoiceData}
        resData={resData}

      />
    </>
  );
};


const mapDispatchToProps = (dispatch) => {
  return {
    getPayoutRemarks: (data) => dispatch(getPayoutRemarksSuccess(data)),
    PartnerRemarkadd: (data) => dispatch(addPayoutRemarksSuccess(data)),
    resolveQuery: (data) => dispatch(getResolvePayoutQueryInternalAction(data)),
    RaiseQuery: (data) => dispatch(getRaisePayoutQueryInternalAction(data)),
    partnerApprovalStagesSuccess: (data) => dispatch(partnerApprovalStagesSuccess(data)),
    getInvoiceData: (data) => dispatch(getInvoiceData(data))
  }
};

const mapStateToProps = (state) => {
  // console.log('stateData:', state.pricigPartner.state.partnerDetail);
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerListWithPayout);